<template>
  <solution-sheet-item :title="title">
    <solution-sheet-sub-item :title="$t('Pressão')" v-if="pressureLoadValue">
      <template v-if="isByBand">
        <table class="solution_sheet__item__val_table">
          <tr>
            <td>W1: {{ pressureLoadValue[0][0] }}kN/m2</td>
            <td>L1: {{ pressureLoadValue[0][1] }}m</td>
          </tr>

          <tr>
            <td>W2: {{ pressureLoadValue[1][0] }}kN/m2</td>
            <td>L2: {{ pressureLoadValue[1][1] }}m</td>
          </tr>

          <tr>
            <td>W3: {{ pressureLoadValue[2][0] }}kN/m2</td>
            <td>L3: {{ pressureLoadValue[2][1] }}m</td>
          </tr>
        </table>

        <template slot="illustration">
          <calc-illustration
            which="genericLoad"
            :is-span-by-span="isWindPressureSpanBySpan"
          />
        </template>
      </template>

      <p v-else>
        <span> {{ pressureLoadValue[0][0] }}kN/m2 </span>
      </p>
    </solution-sheet-sub-item>

    <solution-sheet-sub-item :title="$t('Sucção')" v-if="suctionLoadValue">
      <template v-if="isByBand">
        <table class="solution_sheet__item__val_table">
          <tr>
            <td>W1: {{ suctionLoadValue[0][0] }}kN/m2</td>
            <td>L1: {{ suctionLoadValue[0][1] }}m</td>
          </tr>

          <tr>
            <td>W2: {{ suctionLoadValue[1][0] }}kN/m2</td>
            <td>L2: {{ suctionLoadValue[1][1] }}m</td>
          </tr>

          <tr>
            <td>W3: {{ suctionLoadValue[2][0] }}kN/m2</td>
            <td>L3: {{ suctionLoadValue[2][1] }}m</td>
          </tr>
        </table>

        <template slot="illustration">
          <calc-illustration
            which="windSuction"
            :is-span-by-span="isWindSuctionSpanBySpan"
          />
        </template>
      </template>

      <p v-else>
        <span> {{ suctionLoadValue[0][0] }}kN/m2 </span>
      </p>
    </solution-sheet-sub-item>

    <template #illustration v-if="!isByBand">
      <calc-illustration which="genericLoad" />
    </template>
  </solution-sheet-item>
</template>

<script>
import { withoutDuplicates } from "@/utils";
import {
  SolutionSheetItem,
  SolutionSheetSubItem,
  CalcIllustration,
} from "@/components";

export default {
  components: {
    CalcIllustration,
    SolutionSheetItem,
    SolutionSheetSubItem,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    pressureLoadValue: {
      required: true,
      // type: [null, Array],
    },

    suctionLoadValue: {
      required: true,
      // type: [null, Array],
    },

    isByBand: {
      default: true,
      required: true,
      // type: Boolean
    },
  },

  data() {
    return {};
  },

  computed: {
    isWindPressureSpanBySpan() {
      return withoutDuplicates(this.pressureLoadValue).length !== 1;
    },

    isWindSuctionSpanBySpan() {
      return withoutDuplicates(this.suctionLoadValue).length !== 1;
    },
  },
};
</script>
